import { StringUtils } from 'src/app/services/utils/string.utils';

export class TaskPropertiesObject {


    constructor(private assignedTo: string, private taskId: string, private type: string, private taskName: string,
        private taskProcessId: string, private taskProcessFlowChart: string, private taskService: string, private taskOrder: string,
        private taskOrderType: string) {
    }

    public static create(): TaskPropertiesObject {
        return new TaskPropertiesObject(null, StringUtils.NOT_AVALIABLE,
            StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE,
            StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE, StringUtils.NOT_AVALIABLE);
    }

    public getAssignedTo() {
        return this.assignedTo;
    }

    public getTaskId() {
        return this.taskId;
    }

    public getType() {
        return this.type;
    }

    public getTaskName() {
        return this.taskName;
    }

    public getTaskProcessId() {
        return this.taskProcessId;
    }

    public getTaskProcessFlowChart() {
        return this.taskProcessFlowChart;
    }

    public getTaskService() {
        return this.taskService;
    }

    public getTaskOrder() {
        return this.taskOrder;
    }

    public getTaskOrderType() {
        return this.taskOrderType;
    }

    isBilling(): boolean {
        return this.getTaskName().toLowerCase().includes('billing');
    }


}
